import React from 'react';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';
import TrackVisibility from 'react-on-screen';
import { FaFileInvoiceDollar, FaClipboardCheck, FaBookOpen, FaChartLine, FaMoneyCheckAlt, FaUsers, FaCashRegister, FaBoxes } from "react-icons/fa";


const AboutFour = ({ title, module, moduleTitle, moduleDescriptionFirst, moduleDescriptionLast, image, firstIcon, secondIcon }) => {
    
    let FirstIcon;
    let SecondIcon;
    let firstText;
    let secondText;

    switch (title) {

        case 'Facturación':
            FirstIcon = FaFileInvoiceDollar;
            SecondIcon = FaClipboardCheck;

            firstText = 'Emisión y administración';
            secondText = 'Seguimiento de comprobantes';
            break;

        case 'Contabilidad':
            FirstIcon = FaBookOpen;
            SecondIcon = FaChartLine;

            firstText = 'Información organizada';
            secondText = 'Control financiero';
            break;

        case 'Nomina':
            FirstIcon = FaMoneyCheckAlt;
            SecondIcon = FaUsers;

            firstText = 'Gestión de nómina';
            secondText = 'Control de personal';
            break;

        case 'Punto De Venta':
            FirstIcon = FaCashRegister;
            SecondIcon = FaBoxes;

            firstText = 'Ventas ágiles';
            secondText = 'Control de inventario';
            break;

        default:
            FirstIcon = FaFileInvoiceDollar;
            SecondIcon = FaClipboardCheck;

            firstText = '';
            secondText = '';
            break;
    }

    return (
            <div className="section section-padding case-study-featured-area">
                <div className="container">
                    <div className="row">
                    <div className="col-xl-7 col-lg-6">
                        <div className="case-study-featured-thumb text-start">
                        <img src={image} alt="travel" />
                        </div>
                    </div>
                    <div className="col-xl-5 col-lg-6">
                        <div className="case-study-featured">
                        <div className="section-heading heading-left">
                            <span className="subtitle">{module}</span>
                            <h2 className="title">{moduleTitle}</h2>
                            <p>{moduleDescriptionFirst}</p>
                            <p>{moduleDescriptionLast}</p>
                            {/* <Link to="#" className="axil-btn btn-fill-primary btn-large">Read More</Link> */}
                        </div>
                            <div className="case-study-counterup" style={{ display: 'flex', justifyContent: 'center', alignItems: 'stretch', width: '100%' }}>
                                <div className="single-counterup" style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '10px 35px' }}>
                                    {/* <h2 className="count-number">
                                    <TrackVisibility once>
                                        {({isVisible}) => (
                                            <span className="number count">
                                                {isVisible ? <CountUp end="200" duration={1} /> : null}
                                            </span>
                                        )}  
                                    </TrackVisibility>
                                    <span className="symbol">+</span>
                                    </h2> */}
                                    <h2 className="count-number" >
                                        <span className="mail-icon"><FirstIcon /> </span>
                                    </h2>
                                    <span className="counter-title">{firstText}</span>
                                    </div>
                                    <div className="single-counterup" style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '10px 35px' }}>
                                    {/* <h2 className="count-number">
                                    <TrackVisibility once>
                                        {({isVisible}) => (
                                            <span className="number count"> //CONTADOR CON EFECTO
                                                {isVisible ? <CountUp end="500" duration={1} /> : null}
                                            </span>
                                        )}  
                                    </TrackVisibility>
                                    <span className="symbol">+</span>
                                    </h2> */}
                                    <h2 className="count-number">
                                        <span className="mail-icon"><SecondIcon /> </span>
                                    </h2>
                                    <span className="counter-title">{secondText}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default AboutFour;